/* eslint-disable no-undef */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';
import packageJson from '../package.json';

global.appVersion = packageJson.version;

// Guards against a reload loop if meta.json and the shipped bundle ever
// disagree permanently (a bad deploy, a CDN serving a stale meta.json).
const RELOAD_GUARD_KEY = 'fastays:cache-bust-reloaded';

// version from response - first param, local version second param
const semverGreaterThan = (versionA, versionB) => {
  if (typeof versionA !== 'string' || typeof versionB !== 'string')
    return false;

  const versionsA = versionA.split(/\./g);
  const versionsB = versionB.split(/\./g);

  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());
    const b = Number(versionsB.shift());
    // eslint-disable-next-line no-continue
    if (a === b) continue;
    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b);
  }
  return false;
};

const safeSessionGet = (key) => {
  try {
    return window.sessionStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

const safeSessionSet = (key, value) => {
  try {
    window.sessionStorage.setItem(key, value);
  } catch (e) {
    /* storage unavailable - the guard is best effort */
  }
};

class CacheBuster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isLatestVersion: false,
      refreshCacheAndReload: async () => {
        safeSessionSet(RELOAD_GUARD_KEY, '1');
        try {
          if (typeof caches !== 'undefined') {
            const names = await caches.keys();
            await Promise.all(names.map((name) => caches.delete(name)));
          }
        } catch (error) {
          /* best effort */
        }
        try {
          if ('serviceWorker' in navigator) {
            const registrations =
              await navigator.serviceWorker.getRegistrations();
            await Promise.all(
              registrations.map((registration) => registration.unregister()),
            );
          }
        } catch (error) {
          /* best effort */
        }
        window.location.reload();
      },
    };
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;

    // Previously this read `meta.version` straight off the `Response` object -
    // `.json()` was never called - so `latestVersion` was always `undefined`,
    // `semverGreaterThan` threw a TypeError, the unhandled rejection meant
    // `setState` never ran, and `loading` stayed `true` forever. The version
    // check has never actually run. It also had no `.catch`, so any network
    // hiccup left the whole app blank.
    fetch(`/meta.json?${new Date().getTime()}`, { cache: 'no-store' })
      .then((response) => (response.ok ? response.json() : null))
      .then((meta) => {
        if (!this.mounted) return;

        const latestVersion = meta && meta.version;
        const currentVersion = global.appVersion;
        const alreadyReloaded = safeSessionGet(RELOAD_GUARD_KEY) === '1';

        const shouldForceRefresh =
          !alreadyReloaded && semverGreaterThan(latestVersion, currentVersion);

        if (!shouldForceRefresh) safeSessionSet(RELOAD_GUARD_KEY, '');

        this.setState({
          loading: false,
          isLatestVersion: !shouldForceRefresh,
        });
      })
      .catch(() => {
        // The version check must never be able to block the app from rendering.
        if (this.mounted) {
          this.setState({ loading: false, isLatestVersion: true });
        }
      });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    const { loading, isLatestVersion, refreshCacheAndReload } = this.state;
    return this.props.children({
      loading,
      isLatestVersion,
      refreshCacheAndReload,
    });
  }
}

export default CacheBuster;
